import useDropdown from "../../util/hooks/useDropDown";
import CustomButton from "../../components/CustomButton";
import {
  copy,
  enquiry,
  mail,
  share,
  shareOnWhatsapp,
  whatsAppNewNumber,
} from "../../asset";
import CustomInput from "../../components/CustomInput";
import { useState } from "react";
import {
  openWhatsApp,
  queryLink,
  queryMessageBuilder,
  sendEmail,
} from "../../util/functions/UniversalFunctions";
import ShareLinksPopup from "../../components/modal/ShareLinksPopup";
import { useSelector } from "react-redux";
import { RootState } from "../../store";

export default function ShareQueriesDropDown() {
  const { isOpen, toggleDropdown, dropdownRef } = useDropdown();
  const [showLinkModal, setShowLinkModal] = useState(false);

  const branchCode = useSelector(
    (state: RootState) => state.access.schoolBranch.schoolBranchCode,
  );

  const branchName = useSelector(
    (state: RootState) => state.access.schoolBranch.schoolBranchName,
  );

  const generatedLink = queryLink(branchCode);
  const generatedMessage = queryMessageBuilder(branchName, branchCode);

  const [phone, setPhone] = useState("");

  const copylinkHandler = () => {
    setShowLinkModal(true);
  };

  const closeModal = () => {
    setShowLinkModal(false);
  };

  const menuItems = [
    {
      label: "Copy Message Link",
      icon: copy,
      onClick: copylinkHandler,
    },
    {
      label: "Enquiry Poster",
      icon: enquiry,
    },
    {
      label: "Send via Email",
      icon: mail,
      onClick: () => sendEmail(generatedMessage),
    },
    {
      label: "Share on WhatsApp",
      icon: shareOnWhatsapp,
      onClick: () => openWhatsApp(generatedMessage),
    },
  ];

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <div className="flex justify-end items-end">
        <CustomButton
          text="Share"
          color="bg-success-500"
          icon={share}
          onClick={toggleDropdown}
        />
      </div>
      {showLinkModal && (
        <ShareLinksPopup
          title="Queries Link"
          link={generatedLink}
          onClose={closeModal}
        />
      )}

      <div
        className={`absolute right-0 mt-2 p-2 bg-white rounded-lg shadow-xl
    z-50 transition-all duration-200 
    ${isOpen ? "opacity-100 visible" : "opacity-0 invisible"}`}
      >
        <ul className="flex flex-col gap-2 py-3 text-sm text-neutral-600 font-medium">
          {menuItems.map((item) => (
            <li
              key={item.label}
              onClick={item.onClick}
              className={`px-4 py-2 gap-2 cursor-pointer flex font-medium text-neutral-600 text-sm items-center rounded-md hover:bg-background-300
               `}
            >
              <img src={item.icon} alt={item.label} className="w-4 h-4" />
              <span>{item.label}</span>
            </li>
          ))}
          <li
            className={`px-4 py-2 gap-2 flex-col cursor-pointer flex font-medium text-neutral-600 text-sm items-center rounded-md hover:bg-background-300
               `}
          >
            <div className="flex gap-2 items-start">
              <img
                src={whatsAppNewNumber}
                alt="icon"
                className="w-4 h-4 mt-1"
              />
              <label>Send to New WhatsApp Number</label>
            </div>
            <div className="flex flex-col gap-3 w-full">
              <CustomInput
                name="phone"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="Enter 10-digit number"
              />
              <CustomButton
                color="bg-primary-500"
                text="Send"
                onClick={() => openWhatsApp(generatedLink, phone)}
              />
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}
